import { SVGProps } from "react";

const ArrowLeftIcon = ({
  width = "24",
  height = "24",
  fill,
  ...props
}: SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    xmlns="http://www.w3.org/2000/svg"
    fillRule="evenodd"
    clipRule="evenodd"
    fill={fill}
    viewBox={`${(24 - parseFloat(width.toString())) / 2} ${
      (24 - parseFloat(height.toString())) / 2
    } ${width} ${height}`}
  >
    <path d="M20 .755l-14.374 11.245 14.374 11.219-.619.781-15.381-12 15.391-12 .609.755z" />
  </svg>
);

export default ArrowLeftIcon;
